import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent } from '@/components/ui/card'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/hr/me/profile')({
  component: MyProfilePage,
})

function MyProfilePage() {
  const { data, isLoading } = useQuery(orpc.hr.me.getOwnProfile.queryOptions({ input: {} }))
  const profile = data as {
    id: number
    employeeNumber: string | null
    firstName: string
    lastName: string | null
    email: string | null
    status: string | null
    departmentId: number | null
  } | null

  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6 text-muted-foreground">Loading...</CardContent>
      </Card>
    )
  }
  if (!profile) {
    return (
      <Card>
        <CardContent className="p-6 text-muted-foreground">No employee record found.</CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent className="p-6 space-y-3">
        <Field label="Employee number" value={profile.employeeNumber} />
        <Field label="Name" value={`${profile.firstName} ${profile.lastName ?? ''}`.trim()} />
        <Field label="Email" value={profile.email} />
        <Field label="Status" value={profile.status} />
      </CardContent>
    </Card>
  )
}

function Field({ label, value }: { label: string; value: string | number | null | undefined }) {
  return (
    <div className="grid grid-cols-3 gap-3 py-1 border-b last:border-b-0">
      <div className="text-sm font-medium text-muted-foreground">{label}</div>
      <div className="col-span-2 text-sm">{value ?? '-'}</div>
    </div>
  )
}
